import React, { useState } from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import ProfilePicture from "./../ProfilePicture";
import ImageUploader from "../../../shared/ImageUploader";

export default (props) => {
  const {
    className,
    user,
    disabled,
    onClick,
    editProfilePicture,
    forwardedRef,
    noProfilePicture = false,
    noUsername = false,
    setImageUrl,
    isVertical = false,
  } = props;

  const [userDetails, setUserDetails] = useState(user);

  const handleSubmit = (s3_object_key, fileUrl) => {
    setUserDetails({
      ...userDetails,
      profile_picture: {
        url: URL.createObjectURL(fileUrl),
      },
    });
    setImageUrl(s3_object_key);
  };

  return disabled ? (
    <span
      ref={forwardedRef}
      className={`media usertag ${className}`}
      onClick={onClick}
      style={isVertical ? { flexDirection: "column", alignItems: "center" } : {}}
    >
      {editProfilePicture ? (
        <ImageUploader onSubmit={handleSubmit} className="edit_picture_overlay mr-3">
          <ProfilePicture user={userDetails} />
        </ImageUploader>
      ) : (
        <ProfilePicture user={userDetails} className="mr-3" />
      )}
      <p className="m-auto text-dark display-name-wrap">{userDetails.username}</p>
    </span>
  ) : (
    <a ref={forwardedRef} className={`media usertag ${className}`} href={`/${userDetails.slug}`}>
      {!noProfilePicture ? <ProfilePicture user={userDetails} className="mr-3" /> : null}
      {!noUsername ? (
        <p style={{ cursor: "pointer" }} className="my-auto text-dark font-weight-bold">
          {userDetails.username}
        </p>
      ) : null}
    </a>
  );
};
